import { render, staticRenderFns } from "./BriefsHeader.vue?vue&type=template&id=17fc288d&scoped=true"
import script from "./BriefsHeader.vue?vue&type=script&lang=js"
export * from "./BriefsHeader.vue?vue&type=script&lang=js"
import style0 from "./BriefsHeader.vue?vue&type=style&index=0&id=17fc288d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17fc288d",
  null
  
)

export default component.exports